import { render } from "./tieling.vue?vue&type=template&id=b4134832&scoped=true"
import script from "./tieling.vue?vue&type=script&lang=js"
export * from "./tieling.vue?vue&type=script&lang=js"

import "./tieling.vue?vue&type=style&index=0&id=b4134832&lang=scss&scoped=true"

import exportComponent from "C:\\xiangmu\\gas-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4134832"]])

export default __exports__